<template>
  <div id="Contratacao">
    <div class="mobile-component">
      <el-carousel
        :interval="4000"
        type="card"
        height="120px"
        class="carousel"
      >
        <el-carousel-item>
          <el-card shadow="always">
            <div class="status">
              <p class="titulo">
                Em oferta
              </p>
              <p class="total texto-vermelho">
                {{ oferta }}
              </p>
            </div>
          </el-card>
        </el-carousel-item>
        <el-carousel-item>
          <el-card shadow="always">
            <div class="status">
              <p class="titulo">
                Em negociação
              </p>
              <p class="total texto-vermelho">
                {{ negociacao }}
              </p>
            </div>
          </el-card>
        </el-carousel-item>
        <el-carousel-item>
          <el-card shadow="always">
            <div class="status">
              <p class="titulo">
                Em coleta
              </p>
              <p class="total texto-vermelho">
                {{ coleta }}
              </p>
            </div>
          </el-card>
        </el-carousel-item>
        <el-carousel-item>
          <el-card shadow="always">
            <div class="status">
              <p class="titulo">
                Em trânsito
              </p>
              <p class="total texto-vermelho">
                {{ transito }}
              </p>
            </div>
          </el-card>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="desktop-component">
      <el-row class="cards">
        <el-col>
          <el-card shadow="always">
            <div class="status">
              <p class="titulo">
                Em oferta
              </p>
              <p class="total texto-vermelho">
                {{ oferta }}
              </p>
            </div>
          </el-card>
        </el-col>
        <el-col>
          <el-card shadow="always">
            <div class="status">
              <p class="titulo">
                Em negociação
              </p>
              <p class="total texto-vermelho">
                {{ negociacao }}
              </p>
            </div>
          </el-card>
        </el-col>
        <el-col>
          <el-card shadow="always">
            <div class="status">
              <p class="titulo">
                Em coleta
              </p>
              <p class="total texto-vermelho">
                {{ coleta }}
              </p>
            </div>
          </el-card>
        </el-col>
        <el-col>
          <el-card shadow="always">
            <div class="status">
              <p class="titulo">
                Em trânsito
              </p>
              <p class="total texto-vermelho">
                {{ transito }}
              </p>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div style="clear: both" />

    <div class="mobile-component">
      <el-button
        class="botao-vermelho"
        fullscreen="true"
        type="text"
        @click="dialogVisible = true"
      >
        Clique para visualizar as opções de filtro
      </el-button>

      <el-dialog
        title="Filtros"
        fullscreen
        :visible.sync="dialogVisible"
        width="30%"
      >
        <el-row class="filtros">
          <el-col>
            <p style="font-size: 12px; margin-left: 1px">
              Embarcador:
            </p>
            <el-select
              v-model="filtro.embarcador"
              placeholder="Selecione para filtrar..."
              style="margin-left: 1px; width: 100%"
              clearable
            >
              <el-option
                v-for="item in optionsEmbarcador"
                :key="item.id"
                :label="item.nome"
                :value="item.id"
              />
            </el-select>
          </el-col>
          <el-col>
            <p style="font-size: 12px; margin-left: 1px">
              Carga:
            </p>
            <el-input
              v-model="filtro.carga"
              placeholder="Digite para filtrar..."
              debounce="500"
              style="margin-left: 1px"
            />
          </el-col>
          <el-col>
            <p style="font-size: 12px; margin-left: 1px">
              Motorista:
            </p>
            <el-input
              v-model="filtro.motorista"
              placeholder="Digite para filtrar..."
              debounce="500"
              style="margin-left: 1px"
            />
          </el-col>
          <el-col>
            <p style="font-size: 12px; margin-left: 1px">
              Status:
            </p>
            <el-select
              v-model="filtro.status"
              placeholder="Selecione para filtrar..."
              style="margin-left: 1px; width: 100%"
              clearable
            >
              <el-option
                v-for="item in optionsStatus"
                :key="item.id"
                :label="item.nome"
                :value="item.id"
              />
            </el-select>
          </el-col>
        </el-row>
      </el-dialog>
    </div>

    <div class="desktop-component">
      <div style="margin-top: 30px; margin-bottom: 10px; font-size: 13px">
        Filtros:
      </div>
      <el-row class="filtros">
        <el-col>
          <p style="font-size: 12px; margin-left: 1px">
            Embarcador:
          </p>
          <el-select
            v-model="filtro.embarcador"
            placeholder="Selecione para filtrar..."
            style="margin-left: 1px; width: 100%; color: #dc2626"
            clearable
          >
            <el-option
              v-for="item in optionsEmbarcador"
              :key="item.id"
              :label="item.nome"
              :value="item.id"
            />
          </el-select>
        </el-col>
        <el-col>
          <p style="font-size: 12px; margin-left: 1px">
            Carga:
          </p>
          <el-input
            v-model="filtro.carga"
            placeholder="Digite para filtrar..."
            debounce="500"
            style="margin-left: 1px"
          />
        </el-col>
        <el-col>
          <p style="font-size: 12px; margin-left: 1px">
            Motorista:
          </p>
          <el-input
            v-model="filtro.motorista"
            placeholder="Digite para filtrar..."
            debounce="500"
            style="margin-left: 1px"
          />
        </el-col>
        <el-col>
          <p style="font-size: 12px; margin-left: 1px">
            Status:
          </p>
          <el-select
            v-model="filtro.status"
            placeholder="Selecione para filtrar..."
            style="margin-left: 1px; width: 100%"
            clearable
          >
            <el-option
              v-for="item in optionsStatus"
              :key="item.id"
              :label="item.nome"
              :value="item.id"
            />
          </el-select>
        </el-col>
      </el-row>
    </div>

    <div style="color: #848484; font-size: 12px; margin-bottom: 35px; margin-top: 10px">
      Exibindo {{ filtro.total }} de {{ fretesRaw.length }} registro(s)
      |
      <a
        class="texto-vermelho"
        style="cursor: pointer; text-decoration:underline;"
        id="downloadLink"
        href="#"
        @click="gerarPlanilha"
      >
        Exportar
      </a>
    </div>

    <div v-if="isMobile">
      <div
        class="mobile-component"
        v-for="f in fretes"
        :key="f.embarcadorId"
      >
        <div v-if="f.fretes.length > 0">
          <el-divider content-position="left">
            {{ f.embarcadorNome | toUpperCase }}
          </el-divider>
          <div
            v-for="frete in f.fretes"
            :key="frete.id"
          >
            <div @click="Abrir(frete)">
              <el-card
                class="cardContratacao"
                style="margin-left:0;margin-right:0"
              >
                <div class="cardCabecalho">
                  <p class="negrito t12 branco">
                    Carga: #{{ frete.id }}
                  </p>
                </div>
                <div class="conteudo">
                  <p
                    class="regular t12 data"
                    style="float: right"
                  >
                    {{ frete.coleta.data | formataData }}
                  </p>
                  <span class="medio t18">{{ frete.coleta.estado.uf }} &rarr; {{ frete.entrega.estado.uf }}</span>
                  <div>
                    <span class="regular t12"> Valor Inicial:</span>
                    <span class="medio t12">{{ frete.valorOfertadoEmbarcador | formataMoeda }}</span>
                  </div>
                  <div>
                    <span class="regular t12">Valor Negociado:</span>
                    <span v-if="frete.menorValorNegociado">
                      <span class="medio t12">{{ frete.menorValorNegociado | formataMoeda }}</span>
                      <span
                        v-if="frete.menorValorNegociado != frete.valorOfertadoEmbarcador"
                        style="font-size: 10px; position: absolute; margin-left: 0; margin-left:5px; margin-top: 6px"
                      >(
                        <span
                          v-if="frete.menorValorNegociado > frete.valorOfertadoEmbarcador"
                          style="color: #dc2626"
                        >
                          {{
                            Math.abs(100 - (frete.menorValorNegociado / frete.valorOfertadoEmbarcador) * 100).toFixed(0)
                          }}% a mais
                        </span>
                        <span
                          v-else
                          style="color: green"
                        >
                          {{
                            Math.abs(100 - (frete.menorValorNegociado / frete.valorOfertadoEmbarcador) * 100).toFixed(0)
                          }}% a menos
                        </span>
                        )
                      </span>
                    </span>
                    <span v-else>-</span>
                  </div>
                  <div>
                    <span class="regular t12">Motoristas Interessados:</span>
                    <span class="medio t12">{{ frete.quantidadeMotoristasInteressados }}</span>
                  </div>
                  <div>
                    <span class="regular t12">Status:</span>
                    <span class="medio t12">{{ status[frete.status].descricao }}</span>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
        <p v-else>
          Não há registros
        </p>
      </div>
    </div>

    <div v-if="!isMobile">
      <div
        class="desktop-component"
        v-for="f in fretes"
        :key="f.embarcadorId"
      >
        <el-divider content-position="left">
          {{ f.embarcadorNome | toUpperCase }}
        </el-divider>
        <el-table
          :data="f.fretes"
          empty-text="Não há registros"
          style="width: 100%; margin-bottom: 30px"
        >
          <el-table-column
            prop="id"
            label="Data Coleta"
            width="130"
          >
            <template slot-scope="scope">
              {{ scope.row.coleta.data | formataData }}
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="Carga"
            width="80"
          >
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column
            prop="trajeto"
            label="Trajeto"
            width="85"
          >
            <template slot-scope="scope">
              {{ scope.row.coleta.estado.uf }}
              &rarr;
              {{ scope.row.entrega.estado.uf }}
            </template>
          </el-table-column>
          <el-table-column
            prop="valorOfertadoEmbarcador"
            label="Valor Inicial"
            width="110"
          >
            <template slot-scope="scope">
              {{ scope.row.valorOfertadoEmbarcador | formataMoeda }}
            </template>
          </el-table-column>
          <el-table-column
            prop="quantidadeMotoristasInteressados"
            label="M.I."
            width="50"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.quantidadeMotoristasInteressados }}
            </template>
          </el-table-column>
          <el-table-column
            prop="menorValorNegociado"
            label="Vlr Negociado"
            width="130"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.menorValorNegociado">
                <div>{{ scope.row.menorValorNegociado | formataMoeda }}</div>
                <span
                  v-if="scope.row.menorValorNegociado != scope.row.valorOfertadoEmbarcador"
                  style="font-size: 10px; position: absolute; margin-left: 0; margin-top: -5px"
                >
                  <span
                    v-if="scope.row.menorValorNegociado > scope.row.valorOfertadoEmbarcador"
                    style="color: #dc2626"
                  >
                    {{
                      Math.abs(100 - (scope.row.menorValorNegociado / scope.row.valorOfertadoEmbarcador) * 100).toFixed(
                        0
                      )
                    }}% a mais
                  </span>
                  <span
                    v-else
                    style="color: green"
                  >
                    {{
                      Math.abs(100 - (scope.row.menorValorNegociado / scope.row.valorOfertadoEmbarcador) * 100).toFixed(
                        0
                      )
                    }}% a menos
                  </span>
                </span>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            width="120"
          >
            <template slot-scope="scope">
              {{ status[scope.row.status].descricao }}
            </template>
          </el-table-column>
          <el-table-column
            prop="tempo"
            label="Situação"
          >
            <template slot-scope="scope">
              <ul>
                <li
                  v-for="(mensagem, index) in scope.row.pendencia.mensagens"
                  :key="index"
                >
                  <span v-if="mensagem.includes('|')">
                    <div
                      v-for="(m, i) in mensagem.split('|')"
                      :key="i"
                    >{{ m }}</div>
                  </span>
                  <span v-else>{{ mensagem }}</span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column
            label="Ação"
            label-class-name="label-center"
            width="98"
          >
            <template slot-scope="scope">
              <el-button
                class="botao-vermelho"
                @click="Abrir(scope.row)"
              >
                Abrir
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div v-if="isMobile">
      <el-dialog
        fullscreen
        :modal="true"
        :title="`Carga #${dialog.data.id} - ${dialog.data.embarcador.nome}`"
        :visible.sync="dialog.visible"
        width="80%"
        :before-close="Fechar"
      >
        <el-descriptions
          class="margin-top"
          :column="3"
          title="Coleta"
          size="medium"
          direction="vertical"
          border
          style="margin-bottom: 25px"
        >
          <el-descriptions-item label-style="width:270px">
            <template slot="label">
              Cidade/Estado
            </template>
            {{ dialog.data.coleta.cidade.nome }}/{{ dialog.data.coleta.estado.uf }}
          </el-descriptions-item>
          <el-descriptions-item label-style="width:160px">
            <template slot="label">
              Data
            </template>
            {{ dialog.data.coleta.data | formataData }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Observação
            </template>
            {{ dialog.data.coleta.observacao ? dialog.data.coleta.observacao : '-' }}
          </el-descriptions-item>
        </el-descriptions>

        <div
          class="margin-top el-descriptions"
          style="margin-bottom: 25px"
        >
          <div class="el-descriptions__header">
            <div class="el-descriptions__title">
              Destino(s)
            </div>
          </div>
        </div>
        <el-table
          :data="dialog.data.entregas"
          border
          style="width: 100%;"
          header-cell-class-name="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
          :cell-style="{ color: '#606266' }"
          :header-cell-style="{ padding: '10px 0 !important', 'background-color': '#fafafa' }"
        >
          <el-table-column
            prop="destino"
            label="Cidade/Estado - Distância"
          >
            <template slot-scope="scope">
              {{ scope.row.cidade.nome }}/{{ scope.row.estado.uf }} - {{ scope.row.distancia | formataMoeda('', 0) }} km
            </template>
          </el-table-column>
          <el-table-column
            prop="produto"
            label="Produto / Embalagem"
          >
            <template slot-scope="scope">
              {{ scope.row.produto | toUpperCase }} /
              {{ scope.row.embalagem | toUpperCase }}
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="dialog.data.entregas"
          border
          style="width: 100%; margin-bottom: 25px"
          header-cell-class-name="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
          :cell-style="{ color: '#606266' }"
          :header-cell-style="{ padding: '10px 0 !important', 'background-color': '#fafafa' }"
        >
          <el-table-column
            prop="peso"
            label="Peso"
          >
            <template slot-scope="scope">
              {{ scope.row.peso | formataMoeda('', 0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="valorNotaFiscal"
            label="Valor Estimado Notas"
          >
            <template slot-scope="scope">
              {{ scope.row.valorNotaFiscal | formataMoeda('', 0) }}
            </template>
          </el-table-column>
        </el-table>

        <el-descriptions
          class="margin-top"
          :column="3"
          title="Valores"
          size="medium"
          direction="vertical"
          border
          style="margin-bottom: 25px"
        >
          <el-descriptions-item
            content-style=""
            label-style="width:100%"
          >
            <template slot="label">
              Oferta incial do embarcador
            </template>
            <span style="color: #dc2626; font-weight: bold">{{
              dialog.data.valorOfertadoEmbarcador | formataMoeda
            }}</span>
            <em
              style="position: absolute; font-size: 10px; margin-left: 10px; margin-top: 2px"
            >({{ (dialog.data.valorOfertadoEmbarcador / dialog.data.distancia).toFixed(2) | formataMoeda }} / KM)</em>
            <div
              v-if="dialog.data.valorOfertadoEmbarcador != precoMedio && precoMedio > 0"
              style="font-size: 11px"
            >
              <hr>
              <span
                v-if="dialog.data.valorOfertadoEmbarcador > precoMedio"
                style="color: green"
              >
                {{ Math.abs(100 - (dialog.data.valorOfertadoEmbarcador / precoMedio) * 100).toFixed(0) }}% acima do
                preço médio
              </span>
              <span
                v-else
                style="color: red"
              >
                {{ Math.abs(100 - (dialog.data.valorOfertadoEmbarcador / precoMedio) * 100).toFixed(0) }}% abaixo do
                preço médio
              </span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label-style="width:50%">
            <template slot="label">
              Valor Pedágio
            </template>
            {{ dialog.data.valorOfertadoPedagio | formataMoeda }}
          </el-descriptions-item>
          <el-descriptions-item label-style="width:50%">
            <template slot="label">
              Valor Descarga
            </template>
            {{ dialog.data.valorOfertadoDescarga | formataMoeda }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions
          class="margin-top"
          :column="3"
          title="Perfil"
          size="medium"
          direction="vertical"
          border
          style="margin-bottom: 25px"
        >
          <el-descriptions-item
            v-if="dialog.data.tiposVeiculo"
            label-style="width:50%"
          >
            <template slot="label">
              Tipo de Veículo
            </template>
            {{ dialog.data.tiposVeiculo.join(', ') }}
          </el-descriptions-item>
          <el-descriptions-item v-if="dialog.data.tiposCarroceria">
            <template slot="label">
              Tipo de Carroceria
            </template>
            {{ dialog.data.tiposCarroceria.join(', ') }}
          </el-descriptions-item>
        </el-descriptions>

        <div
          class="margin-top el-descriptions"
          style="margin-bottom: 25px"
        >
          <div class="el-descriptions__header">
            <div class="el-descriptions__title">
              Negociações
            </div>
            <div
              v-if="dialogNegociacoes.length"
              class="el-descriptions__extra"
            >
              <el-switch
                v-if="!isMobile"
                v-model="dialog.exibirTodosStatusNegociacao"
                active-color="#DC2626"
                inactive-text="Exibir negocição detalhada"
              />
            </div>
          </div>
        </div>

        <el-table
          :data="dialogNegociacoes"
          class="no-hover"
          border
          style="width: 100%; margin-bottom: 25px"
          empty-text="Não há registros"
          header-cell-class-name="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
          :cell-style="{ color: '#606266' }"
          :header-cell-style="{ padding: '10px 0 !important', 'background-color': '#fafafa' }"
        >
          <el-table-column
            prop="nome"
            label="Motorista"
          >
            <template slot-scope="scope">
              <div @click="AbrirNegociacao(scope.row, scope.row.negociacoes[0])">
                <el-tooltip
                  v-if="scope.row.negociacoes[0].usuarioCadastroNome"
                  :content="`Cadastrador: ${scope.row.negociacoes[0].usuarioCadastroNome}`"
                  placement="top"
                >
                  <div style="float: right; margin-top: 8px">
                    <el-tag type="warning">
                      C
                    </el-tag>
                  </div>
                </el-tooltip>
                <el-tooltip
                  v-if="scope.row.negociacoes[scope.row.negociacoes.length - 1].espontanea"
                  :content="'Espontâneo'"
                  placement="top"
                >
                  <div style="float: right; margin-top: 8px">
                    <el-tag>E</el-tag>
                  </div>
                </el-tooltip>
                <div>{{ scope.row.negociacoes[0].motorista.nome }}</div>
                <em>{{ scope.row.negociacoes[0].motorista.celular | formataTelefone }}</em>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
          :modal="true"
          :append-to-body="true"
          :title="dialogNegociacao.data ? 'Motorista: ' + dialogNegociacao.data.motoristaNome : ''"
          :visible.sync="dialogNegociacao.visible"
          :before-close="FecharNegociacao"
          width="80%"
          top="25vh"
        >
          <div v-if="dialogNegociacao.data">
            <el-timeline>
              <el-timeline-item
                v-for="negociacao2 in dialogNegociacao.data.negociacoes"
                :key="negociacao2.id"
                :timestamp="negociacao2.data | formataData"
              >
                {{ negociacao2.statusDescricao }}
                <span
                  v-if="negociacao2.status !== 'TRANSPORTADOR_OFERTA_CANCELADA' && negociacao2.contraOferta > 0"
                >de {{ negociacao2.contraOferta | formataMoeda }}</span>
              </el-timeline-item>
            </el-timeline>

            <div
              v-for="negociacao3 in dialogNegociacao.data.negociacoes"
              :key="negociacao3.id"
              style="margin-top:20px "
            >
              <div v-if="!dialogNegociacao.data.negociacoes.some((negociacao3) => negociacao3.bloqueada)">
                <div
                  v-if="negociacao3 === dialogNegociacao.data.negociacoes[dialogNegociacao.data.negociacoes.length - 1]"
                >
                  <div v-if="negociacao3.status === 'TRANSPORTADOR_OFERTA_ACEITA'">
                    <el-button
                      class="botao-vermelho"
                      @click="DesitirFrete(negociacao3.id)"
                      v-loading="dialog.desistindo === negociacao3.id"
                      :disabled="dialog.desistindo === negociacao3.id"
                    >
                      Desistir
                    </el-button>
                  </div>
                  <div v-if="negociacao3.status === 'TRANSPORTADOR_SELECIONADO_AVALIACAO_RISCO'">
                    Em avaliação de risco
                  </div>
                  <div v-if="negociacao3.status === 'TRANSPORTADOR_OFERTA_NEGOCIADA'">
                    <el-button
                      class="botao-vermelho"
                      @click="DesitirFrete(negociacao3.id)"
                      v-loading="dialog.desistindo === negociacao3.id"
                      :disabled="dialog.desistindo === negociacao3.id"
                    >
                      Desistir
                    </el-button>
                  </div>
                  <div v-if="negociacao3.status === 'EMBARCADOR_OFERTA_NEGOCIADA'">
                    <el-button
                      class="botao-vermelho"
                      @click="AceitarContraofertaFrete(negociacao3.id)"
                      v-loading="dialog.aceitando === negociacao3.id"
                      :disabled="dialog.aceitando === negociacao3.id"
                      style="margin-bottom: 10px;"
                    >
                      Aceitar
                    </el-button>
                    <el-button
                      class="botao-vermelho"
                      @click="DesitirFrete(negociacao3.id)"
                      v-loading="dialog.desistindo === negociacao3.id"
                      :disabled="dialog.desistindo === negociacao3.id"
                      style="margin-left: 0px"
                    >
                      Desistir
                    </el-button>
                  </div>
                  <div v-if="negociacao3.status === 'TRANSPORTADOR_OFERTA_CANCELADA'">
                    <el-button
                      class="botao-vermelho"
                      @click="EstornarDesistencia(negociacao3.id)"
                      v-loading="dialog.estornando === negociacao3.id"
                      :disabled="dialog.estornando === negociacao3.id"
                    >
                      Estornar
                    </el-button>
                  </div>
                  <div v-if="negociacao3.status === 'TRANSPORTADOR_REPROVADO_GERENCIADORA_RISCO'">
                    Este motorista foi reprovado por {{ negociacao3.usuarioCadastroNome }}
                  </div>
                </div>
              </div>
              <div v-else>
                Ação bloqueada
              </div>
            </div>
          </div>
        </el-dialog>

        <span
          slot="footer"
          class="dialog-footer"
        >
          <div>
            <el-button
              class="botao-vermelho"
              v-if="dialogPodeAdicionarNegociacao"
              @click="AbrirAdicaoNegociacao"
            >
              Adicionar Negociação
            </el-button>
          </div>
        </span>

        <div v-if="isMobile">
          <el-dialog
            fullscreen
            :title="`Carga #${dialog.data.id} - Adicionar negociação`"
            :visible.sync="dialogAdicaoNegociacao.visible"
            class="dialog"
            :before-close="FecharAdicaoNegociacao"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            append-to-body
          >
            <el-form
              :model="dialogAdicaoNegociacao.form"
              :rules="dialogAdicaoNegociacaoRules"
              ref="formDialogAdicaoNegociacao"
            >
              <el-divider content-position="left">
                DADOS DO MOTORISTA
              </el-divider>
              <div style="">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item
                      label="CPF"
                      prop="cpf"
                      class="form-group"
                    >
                      <el-input
                        @blur="BuscarMototoristaPorCpf"
                        v-model="dialogAdicaoNegociacao.form.cpf"
                        v-mask="'###.###.###-##'"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-alert
                      type="warning"
                      :closable="false"
                      style="padding: 2px 10px;word-break:normal;"
                    >
                      <b>Ateção!</b> Campo <b>não</b> obrigatório, porém ao informá-lo é possível vincular automaticamente ao usuário.
                    </el-alert>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item
                      label="CELULAR"
                      prop="celular"
                      class="form-group"
                    >
                      <el-input
                        @blur="BuscarMototoristaPorCelular"
                        v-model="dialogAdicaoNegociacao.form.celular"
                        v-mask="'(##) # ####-####'"
                      />
                    </el-form-item>
                    <span
                      v-if="dialogBuscandoMotorista"
                      style="color: #f56c6c; font-size: 12px; position: absolute; margin-top: -19px"
                    >Buscando motorista...</span>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="NOME COMPLETO"
                      prop="nome"
                      class="form-group"
                    >
                      <el-input v-model="dialogAdicaoNegociacao.form.nome" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-divider content-position="left">
                DADOS DO VEÍCULO
              </el-divider>
              <div style="">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item
                      label="TIPO CARROCERIA"
                      prop="carroceriaTipo"
                      class="form-group"
                    >
                      <el-select
                        v-model="dialogAdicaoNegociacao.form.carroceriaTipo"
                        filterable
                        style="width: 100%"
                      >
                        <el-option-group
                          v-for="group in options.tiposCarroceria"
                          :key="group.label"
                          :label="group.label"
                        >
                          <el-option
                            v-for="item in group.options"
                            :key="item.id"
                            :label="item.descricao"
                            :value="item.id"
                          />
                        </el-option-group>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="TIPO CAVALO"
                      prop="veiculoTipo"
                      class="form-group"
                    >
                      <el-select
                        v-model="dialogAdicaoNegociacao.form.veiculoTipo"
                        filterable
                        style="width: 100%"
                      >
                        <el-option-group
                          v-for="group in options.tiposVeiculo"
                          :key="group.label"
                          :label="group.label"
                        >
                          <el-option
                            v-for="item in group.options"
                            :key="item.id"
                            :label="item.descricao"
                            :value="item.id"
                          />
                        </el-option-group>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="PLACA VEÍCULO"
                      prop="veiculoPlaca"
                      class="form-group"
                    >
                      <el-input
                        @input="
                          (v) => {
                            dialogAdicaoNegociacao.form.veiculoPlaca = v.toUpperCase()
                          }
                        "
                        v-model="dialogAdicaoNegociacao.form.veiculoPlaca"
                        :maxlength="7"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item
                      label="PLACA CARRETA"
                      prop="carretaPlaca"
                      class="form-group"
                    >
                      <el-input
                        @input="
                          (v) => {
                            dialogAdicaoNegociacao.form.carretaPlaca = v.toUpperCase()
                          }
                        "
                        v-model="dialogAdicaoNegociacao.form.carretaPlaca"
                        :maxlength="7"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="PLACA CAR. ADICIONAL"
                      prop="carretaAdicionalPlaca"
                      class="form-group"
                    >
                      <el-input
                        @input="
                          (v) => {
                            dialogAdicaoNegociacao.form.carretaAdicionalPlaca = v.toUpperCase()
                          }
                        "
                        v-model="dialogAdicaoNegociacao.form.carretaAdicionalPlaca"
                        :maxlength="7"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-divider content-position="left">
                DADOS DA NEGOCIAÇÃO
              </el-divider>
              <div>
                <el-form-item
                  label="VALOR"
                  prop="valor"
                  class="form-group"
                >
                  <el-input
                    v-model="dialogAdicaoNegociacao.form.valor"
                    v-money="{ masked: true }"
                  />
                </el-form-item>
              </div>
            </el-form>
            <span>
              <el-button
                class="botao-vermelho"
                @click="AdicionarNegociacao"
                :disabled="dialogAdicaoNegociacao.adicionando"
              >
                Adicionar
              </el-button>
            </span>
          </el-dialog>
        </div>
      </el-dialog>
    </div>

    <div v-if="!isMobile">
      <el-dialog
        :title="`Carga #${dialog.data.id} - ${dialog.data.embarcador.nome}`"
        :visible.sync="dialog.visible"
        width="80%"
        :before-close="Fechar"
      >
        <el-descriptions
          class="margin-top"
          :column="3"
          title="Coleta"
          size="medium"
          direction="vertical"
          border
          style="margin-bottom: 25px"
        >
          <el-descriptions-item label-style="width:270px">
            <template slot="label">
              Cidade/Estado
            </template>
            {{ dialog.data.coleta.cidade.nome }}/{{ dialog.data.coleta.estado.uf }}
          </el-descriptions-item>
          <el-descriptions-item label-style="width:160px">
            <template slot="label">
              Data
            </template>
            {{ dialog.data.coleta.data | formataData }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Observação
            </template>
            {{ dialog.data.coleta.observacao ? dialog.data.coleta.observacao : '-' }}
          </el-descriptions-item>
        </el-descriptions>

        <div
          class="margin-top el-descriptions"
          style="margin-bottom: 25px"
        >
          <div class="el-descriptions__header">
            <div class="el-descriptions__title">
              Destino(s)
            </div>
          </div>
        </div>
        <el-table
          :data="dialog.data.entregas"
          border
          style="width: 100%; margin-bottom: 25px"
          header-cell-class-name="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
          :cell-style="{ color: '#606266' }"
          :header-cell-style="{ padding: '10px 0 !important', 'background-color': '#fafafa' }"
        >
          <el-table-column
            prop="destino"
            label="Cidade/Estado - Distância"
            width="270"
          >
            <template slot-scope="scope">
              {{ scope.row.cidade.nome }}/{{ scope.row.estado.uf }} - {{ scope.row.distancia | formataMoeda('', 0) }} km
            </template>
          </el-table-column>
          <el-table-column
            prop="produto"
            label="Produto / Embalagem"
          >
            <template slot-scope="scope">
              {{ scope.row.produto | toUpperCase }} /
              {{ scope.row.embalagem | toUpperCase }}
            </template>
          </el-table-column>
          <el-table-column
            prop="peso"
            label="Peso"
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.peso | formataMoeda('', 0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="valorNotaFiscal"
            label="Valor Estimado Notas"
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.valorNotaFiscal | formataMoeda('', 0) }}
            </template>
          </el-table-column>
        </el-table>

        <el-descriptions
          class="margin-top"
          :column="3"
          title="Valores"
          size="medium"
          direction="vertical"
          border
          style="margin-bottom: 25px"
        >
          <el-descriptions-item
            label-style="width:40%"
            content-style=""
          >
            <template slot="label">
              Oferta incial do embarcador
            </template>
            <span style="color: #dc2626; font-weight: bold">{{
              dialog.data.valorOfertadoEmbarcador | formataMoeda
            }}</span>
            <em
              style="position: absolute; font-size: 11px; margin-left: 10px; margin-top: 2px"
            >({{ (dialog.data.valorOfertadoEmbarcador / dialog.data.distancia).toFixed(2) | formataMoeda }} por
              KM)</em>
            <div
              v-if="dialog.data.valorOfertadoEmbarcador != precoMedio && precoMedio > 0"
              style="font-size: 11px"
            >
              <hr>
              <span
                v-if="dialog.data.valorOfertadoEmbarcador > precoMedio"
                style="color: green"
              >
                {{ Math.abs(100 - (dialog.data.valorOfertadoEmbarcador / precoMedio) * 100).toFixed(0) }}% acima do
                preço médio
              </span>
              <span
                v-else
                style="color: red"
              >
                {{ Math.abs(100 - (dialog.data.valorOfertadoEmbarcador / precoMedio) * 100).toFixed(0) }}% abaixo do
                preço médio
              </span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label-style="width:30%">
            <template slot="label">
              Valor Pedágio
            </template>
            {{ dialog.data.valorOfertadoPedagio | formataMoeda }}
          </el-descriptions-item>
          <el-descriptions-item label-style="width:30%">
            <template slot="label">
              Valor Descarga
            </template>
            {{ dialog.data.valorOfertadoDescarga | formataMoeda }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions
          class="margin-top"
          :column="3"
          title="Perfil"
          size="medium"
          direction="vertical"
          border
          style="margin-bottom: 25px"
        >
          <el-descriptions-item
            v-if="dialog.data.tiposVeiculo"
            label-style="width:50%"
          >
            <template slot="label">
              Tipo de Veículo
            </template>
            {{ dialog.data.tiposVeiculo.join(', ') }}
          </el-descriptions-item>
          <el-descriptions-item v-if="dialog.data.tiposCarroceria">
            <template slot="label">
              Tipo de Carroceria
            </template>
            {{ dialog.data.tiposCarroceria.join(', ') }}
          </el-descriptions-item>
        </el-descriptions>

        <div
          class="margin-top el-descriptions"
          style="margin-bottom: 25px"
        >
          <div class="el-descriptions__header">
            <div class="el-descriptions__title">
              Negociações
            </div>
            <div
              v-if="dialogNegociacoes.length"
              class="el-descriptions__extra"
            >
              <el-switch
                v-model="dialog.exibirTodosStatusNegociacao"
                active-color="#DC2626"
                inactive-text="Exibir negocição detalhada"
              />
            </div>
          </div>
        </div>
        <el-table
          class="no-hover"
          :data="dialogNegociacoes"
          border
          style="width: 100%; margin-bottom: 25px"
          empty-text="Não há registros"
          header-cell-class-name="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
          :cell-style="{ color: '#606266' }"
          :header-cell-style="{ padding: '10px 0 !important', 'background-color': '#fafafa' }"
        >
          <el-table-column
            prop="nome"
            label="Motorista"
            width="270"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.negociacoes[0].usuarioCadastroNome"
                :content="`Cadastrador: ${scope.row.negociacoes[0].usuarioCadastroNome}`"
                placement="top"
              >
                <div style="float: right; margin-top: 8px">
                  <el-tag type="warning">
                    C
                  </el-tag>
                </div>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.negociacoes[scope.row.negociacoes.length - 1].espontanea"
                :content="'Espontâneo'"
                placement="top"
              >
                <div style="float: right; margin-top: 8px">
                  <el-tag>E</el-tag>
                </div>
              </el-tooltip>
              <div>{{ scope.row.negociacoes[0].motorista.nome }}</div>
              <em>{{ scope.row.negociacoes[0].motorista.celular | formataTelefone }}</em>
            </template>
          </el-table-column>
          <el-table-column
            prop="negociacao"
            label="Negociação"
          >
            <template slot-scope="scope">
              <el-timeline
                v-if="dialog.exibirTodosStatusNegociacao"
                style="margin-top: 8px"
              >
                <el-timeline-item
                  v-for="negociacao4 in scope.row.negociacoes"
                  :key="negociacao4.id"
                  :timestamp="negociacao4.data | formataData"
                >
                  {{ negociacao4.statusDescricao }}
                  <span
                    v-if="negociacao4.status !== 'TRANSPORTADOR_OFERTA_CANCELADA' && negociacao4.contraOferta > 0"
                  >de {{ negociacao4.contraOferta | formataMoeda }}</span>
                </el-timeline-item>
              </el-timeline>
              <el-timeline
                v-else
                style="margin-top: 8px"
              >
                <el-timeline-item
                  :timestamp="scope.row.negociacoes[scope.row.negociacoes.length - 1].data | formataData"
                >
                  {{ scope.row.negociacoes[scope.row.negociacoes.length - 1].statusDescricao }}
                  <span
                    v-if="
                      scope.row.negociacoes[scope.row.negociacoes.length - 1].status !==
                        'TRANSPORTADOR_OFERTA_CANCELADA' && scope.row.negociacoes[scope.row.negociacoes.length - 1].contraOferta > 0
                    "
                  >de {{ scope.row.negociacoes[scope.row.negociacoes.length - 1].contraOferta | formataMoeda }}</span>
                </el-timeline-item>
              </el-timeline>
            </template>
          </el-table-column>
          <el-table-column
            prop="acao"
            label="Ação"
            width="225"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row.negociacoes.some((negociacao) => negociacao.bloqueada)">
                <div
                  v-if="
                    scope.row.negociacoes[scope.row.negociacoes.length - 1].status === 'TRANSPORTADOR_OFERTA_ACEITA'
                  "
                >
                  <el-button
                    class="botao-vermelho"
                    @click="DesitirFrete(scope.row.negociacoes[scope.row.negociacoes.length - 1].id)"
                    v-loading="dialog.desistindo === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                    :disabled="dialog.desistindo === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                  >
                    Desistir
                  </el-button>
                </div>
                <div
                  v-if="
                    scope.row.negociacoes[scope.row.negociacoes.length - 1].status ===
                      'TRANSPORTADOR_SELECIONADO_AVALIACAO_RISCO'
                  "
                >
                  Em avaliação de risco
                </div>
                <div
                  v-if="
                    scope.row.negociacoes[scope.row.negociacoes.length - 1].status === 'TRANSPORTADOR_OFERTA_NEGOCIADA'
                  "
                >
                  <el-button
                    class="botao-vermelho"
                    @click="DesitirFrete(scope.row.negociacoes[scope.row.negociacoes.length - 1].id)"
                    v-loading="dialog.desistindo === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                    :disabled="dialog.desistindo === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                  >
                    Desistir
                  </el-button>
                </div>
                <div
                  v-if="
                    scope.row.negociacoes[scope.row.negociacoes.length - 1].status === 'EMBARCADOR_OFERTA_NEGOCIADA'
                  "
                >
                  <el-button
                    class="botao-vermelho"
                    @click="AceitarContraofertaFrete(scope.row.negociacoes[scope.row.negociacoes.length - 1].id)"
                    v-loading="dialog.aceitando === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                    :disabled="dialog.aceitando === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                    style="margin-bottom: 10px;"
                  >
                    Aceitar
                  </el-button>
                  <el-button
                    class="botao-vermelho"
                    @click="DesitirFrete(scope.row.negociacoes[scope.row.negociacoes.length - 1].id)"
                    v-loading="dialog.desistindo === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                    :disabled="dialog.desistindo === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                    style="margin-left: 0px"
                  >
                    Desistir
                  </el-button>
                </div>
                <div
                  v-if="
                    scope.row.negociacoes[scope.row.negociacoes.length - 1].status === 'TRANSPORTADOR_OFERTA_CANCELADA'
                  "
                >
                  <el-button
                    class="botao-vermelho"
                    @click="EstornarDesistencia(scope.row.negociacoes[scope.row.negociacoes.length - 1].id)"
                    v-loading="dialog.estornando === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                    :disabled="dialog.estornando === scope.row.negociacoes[scope.row.negociacoes.length - 1].id"
                  >
                    Estornar
                  </el-button>
                </div>
                <div
                  v-if="
                    scope.row.negociacoes[scope.row.negociacoes.length - 1].status ===
                      'TRANSPORTADOR_REPROVADO_GERENCIADORA_RISCO'
                  "
                >
                  Este motorista foi reprovado por
                  {{ scope.row.negociacoes[scope.row.negociacoes.length - 1].usuarioCadastroNome }}
                </div>
              </div>
              <div v-else>
                Ação bloqueada
              </div>
            </template>
          </el-table-column>
        </el-table>

        <span
          slot="footer"
          class="dialog-footer"
        >
          <div>
            <el-button
              class="botao-vermelho"
              v-if="dialogPodeAdicionarNegociacao"
              @click="AbrirAdicaoNegociacao"
            >
              Adicionar Negociação
            </el-button>
          </div>
        </span>

        <el-dialog
          :title="`Carga #${dialog.data.id} - Adicionar negociação`"
          :visible.sync="dialogAdicaoNegociacao.visible"
          class="dialog"
          width="600px"
          :before-close="FecharAdicaoNegociacao"
          :close-on-click-modal="false"
          :destroy-on-close="true"
          append-to-body
        >
          <el-form
            :model="dialogAdicaoNegociacao.form"
            :rules="dialogAdicaoNegociacaoRules"
            ref="formDialogAdicaoNegociacao"
          >
            <el-divider content-position="left">
              DADOS DO MOTORISTA
            </el-divider>
            <div style="padding-left: 20px; padding-right: 20px;">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    label="CPF"
                    prop="cpf"
                    class="form-group"
                  >
                    <el-input
                      @blur="BuscarMototoristaPorCpf"
                      v-model="dialogAdicaoNegociacao.form.cpf"
                      v-mask="'###.###.###-##'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-alert
                    type="warning"
                    :closable="false"
                    style="padding: 2px 10px;word-break:normal;margin-top:10px"
                  >
                    <b>Ateção!</b> Campo <b>não</b> obrigatório, porém ao informá-lo a identificação do carreteiro será acelerada.
                  </el-alert>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    label="CELULAR"
                    prop="celular"
                    class="form-group"
                  >
                    <el-input
                      @blur="BuscarMototoristaPorCelular"
                      v-model="dialogAdicaoNegociacao.form.celular"
                      v-mask="'(##) # ####-####'"
                    />
                  </el-form-item>
                  <span
                    v-if="dialogBuscandoMotorista"
                    style="color: #f56c6c; font-size: 12px; position: absolute; margin-top: -19px"
                  >Buscando motorista...</span>
                </el-col>
                <el-col :span="16">
                  <el-form-item
                    label="NOME COMPLETO"
                    prop="nome"
                    class="form-group"
                  >
                    <el-input v-model="dialogAdicaoNegociacao.form.nome" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-divider content-position="left">
              DADOS DO VEÍCULO
            </el-divider>
            <div style="padding-left: 20px; padding-right: 20px; margin-top: 45px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    label="TIPO CAVALO"
                    prop="veiculoTipo"
                    class="form-group"
                  >
                    <el-select
                      v-model="dialogAdicaoNegociacao.form.veiculoTipo"
                      filterable
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options.tiposVeiculo"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.id"
                          :label="item.descricao"
                          :value="item.id"
                        />
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item
                    label="TIPO CARROCERIA"
                    prop="carroceriaTipo"
                    class="form-group"
                  >
                    <el-select
                      v-model="dialogAdicaoNegociacao.form.carroceriaTipo"
                      filterable
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options.tiposCarroceria"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.id"
                          :label="item.descricao"
                          :value="item.id"
                        />
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    label="PLACA VEÍCULO"
                    prop="veiculoPlaca"
                    class="form-group"
                  >
                    <el-input
                      @input="
                        (v) => {
                          dialogAdicaoNegociacao.form.veiculoPlaca = v.toUpperCase()
                        }
                      "
                      v-model="dialogAdicaoNegociacao.form.veiculoPlaca"
                      :maxlength="7"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="PLACA CARRETA"
                    prop="carretaPlaca"
                    class="form-group"
                  >
                    <el-input
                      @input="
                        (v) => {
                          dialogAdicaoNegociacao.form.carretaPlaca = v.toUpperCase()
                        }
                      "
                      v-model="dialogAdicaoNegociacao.form.carretaPlaca"
                      :maxlength="7"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="PLACA CAR. ADICIONAL"
                    prop="carretaAdicionalPlaca"
                    class="form-group"
                  >
                    <el-input
                      @input="
                        (v) => {
                          dialogAdicaoNegociacao.form.carretaAdicionalPlaca = v.toUpperCase()
                        }
                      "
                      v-model="dialogAdicaoNegociacao.form.carretaAdicionalPlaca"
                      :maxlength="7"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-divider content-position="left">
              DADOS DA NEGOCIAÇÃO
            </el-divider>
            <div style="padding-left: 20px; padding-right: 20px; margin-top: 45px">
              <el-form-item
                label="VALOR"
                prop="valor"
                class="form-group"
              >
                <el-input
                  v-model="dialogAdicaoNegociacao.form.valor"
                  v-money="{ masked: true }"
                />
              </el-form-item>
            </div>
          </el-form>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button
              class="botao-vermelho"
              @click="AdicionarNegociacao"
            >
              Adicionar
            </el-button>
          </span>
        </el-dialog>

        <el-dialog
          :title="`Ultimas ${dialog.ofertasSimilares.length} ofertas similares a carga #${dialog.data.id}`"
          :visible.sync="dialogUltimasOfertas.visible"
          width="90%"
          :before-close="FecharUltimasOfertas"
          append-to-body
        >
          Preço Médio: <span class="texto-vermelho">{{ precoMedio | formataMoeda }}</span> | Preço Médio (por peso):
          <span class="texto-vermelho">{{ precoMedioPorPeso | formataMoeda }}</span> | Preço Médio (por veículo):
          <span
            v-if="precoMedioPorTipoVeiculo"
            class="texto-vermelho"
          >{{ precoMedioPorTipoVeiculo.join(', ') }}</span>

          <el-divider />

          <el-table
            :data="dialog.ofertasSimilares"
            empty-text="Não há registros"
            style="width: 100%; margin-bottom: 30px"
          >
            <el-table-column
              prop="dataAtualizacao"
              label="Término em"
              width="110"
            >
              <template slot-scope="scope">
                {{ scope.row.dataAtualizacao.split(' ')[0] | formataData }}
              </template>
            </el-table-column>
            <el-table-column
              prop="valorNecociadoMotoristaSelecionado"
              label="Valor Negociado"
              width="120"
            >
              <template slot-scope="scope">
                {{ scope.row.valorNecociadoMotoristaSelecionado | formataMoeda }}
              </template>
            </el-table-column>
            <el-table-column label="Notas Fiscais">
              <el-table-column
                prop="pesoNotasFiscais"
                label="Peso"
                width="80"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.pesoNotasFiscais | formataMoeda('', 0) }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="valorNotasFiscais"
                label="Valor"
                width="130"
              >
                <template slot-scope="scope">
                  {{ scope.row.valorNotasFiscais | formataMoeda }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Motorista">
              <el-table-column
                prop="motoristaNome"
                label="Nome"
              />
              <el-table-column
                prop="motoristaCelular"
                label="Celular"
                width="130"
              >
                <template slot-scope="scope">
                  {{ scope.row.motoristaCelular | formataTelefone }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Veículo">
              <el-table-column
                prop="tipoVeiculo"
                label="Tipo"
              />
              <el-table-column
                prop="tipoCarroceria"
                label="Carroceria"
              />
            </el-table-column>
          </el-table>
        </el-dialog>

        <el-dialog
          :title="
            `Ultimas ${dialog.ofertasPorPerfilVeiculo.length} ofertas por perfil de veículo com saída da cidade coleta`
          "
          :visible.sync="dialogMotoristasPorPerfil.visible"
          width="90%"
          :before-close="FecharMotoristasPorPerfil"
          append-to-body
        >
          <el-table
            :data="dialog.ofertasPorPerfilVeiculo"
            empty-text="Não há registros"
            style="width: 100%; margin-bottom: 30px"
          >
            <el-table-column
              prop="dataAtualizacao"
              label="Término em"
              width="110"
            >
              <template slot-scope="scope">
                {{ scope.row.dataAtualizacao.split(' ')[0] | formataData }}
              </template>
            </el-table-column>
            <el-table-column
              prop="valorNecociadoMotoristaSelecionado"
              label="Valor Negociado"
              width="120"
            >
              <template slot-scope="scope">
                {{ scope.row.valorNecociadoMotoristaSelecionado | formataMoeda }}
              </template>
            </el-table-column>
            <el-table-column label="Notas Fiscais">
              <el-table-column
                prop="pesoNotasFiscais"
                label="Peso"
                width="80"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.pesoNotasFiscais | formataMoeda('', 0) }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="valorNotasFiscais"
                label="Valor"
                width="130"
              >
                <template slot-scope="scope">
                  {{ scope.row.valorNotasFiscais | formataMoeda }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Motorista">
              <el-table-column
                prop="motoristaNome"
                label="Nome"
              />
              <el-table-column
                prop="motoristaCelular"
                label="Celular"
                width="130"
              >
                <template slot-scope="scope">
                  {{ scope.row.motoristaCelular | formataTelefone }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Veículo">
              <el-table-column
                prop="tipoVeiculo"
                label="Tipo"
              />
              <el-table-column
                prop="tipoCarroceria"
                label="Carroceria"
              />
            </el-table-column>
          </el-table>
        </el-dialog>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { chain, orderBy } from 'lodash'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx-js-style'
import { confirmar, converteMoeda, formataMoeda, isCpfCnpj } from '../../../../assets/js/helpers'
import services from '../services'

let validateCelular = (rule, value, callback) => {
  if (value === null || value === '') return false
  const celular = value.replace(/[^\d]+/g, '')
  return celular.length !== 11 ? callback(new Error('Valor inválido, celular possui 11 dígitos')) : callback()
}
let validateValorMinimo120 = (rule, value, callback) => {
  return converteMoeda(value) < 120 ? callback(new Error('Este valor não pode ser zero')) : callback()
}
let validatePlaca = (rule, value, callback) => {
  if (value === null || value === '') return true
  value.length !== 7 ? callback(new Error('Valor inválido')) : callback()
}
let validateCpfCnpj = (rule, value, callback) => {
  !isCpfCnpj(value) ? callback(new Error('Valor inválido')) : callback()
}

export default {
  name: 'Contratacao',
  components: {},
  data() {
    return {
      dialog: {
        visible: false,
        data: {
          id: null,
          codigo: null,
          status: null,
          valorOfertadoEmbarcador: null,
          menorValorNegociado: null,
          produto: null,
          peso: 0,
          distancia: null,
          embarcador: {
            id: null,
            nome: null
          },
          coleta: {
            data: null,
            cidade: {
              id: null,
              nome: null
            },
            estado: {
              id: null,
              nome: null,
              uf: null,
              regiao: null
            },
            observacao: ''
          },
          entrega: {
            cidade: {
              id: null,
              nome: null
            },
            estado: {
              id: null,
              nome: null,
              uf: null,
              regiao: null
            }
          },
          quantidadeMotoristasInteressados: null,
          negociacoes: []
        },
        precoMedioCarregando: false,
        ofertasSimilares: [],
        motoristaSelecionado: null,
        ofertasPorPerfilVeiculo: [],
        exibirTodosMotoristas: false,
        exibirTodosStatusNegociacao: false,
        estornando: null,
        desistindo: null,
        aceitando: null,
        consultaAprovada: false
      },
      dialogUltimasOfertas: {
        visible: false
      },
      dialogMotoristasPorPerfil: {
        visible: false
      },
      dialogNegociacao: {
        visible: false,
        data: null
      },
      dialogAdicaoNegociacao: {
        visible: false,
        adicionando: false,
        buscando: false,
        motoristaBuscadoJaCadastrado: false,
        form: {
          freteId: null,
          usuarioId: null,
          celular: null,
          nome: null,
          cpf: null,
          valor: null,
          veiculoTipo: null,
          carroceriaTipo: null,
          veiculoPlaca: null,
          carretaPlaca: null,
          carretaAdicionalPlaca: null
        },
      },
      fretesRaw: [],
      fretes: [],
      status: {
        OF: {
          descricao: 'Em oferta',
          pendencia: 'Aguardando contraoferta de transportadores'
        },
        NE: {
          descricao: 'Em negociação',
          pendencia: 'Aguardando embarcador selecionar transportador'
        },
        AR: {
          descricao: 'Em negociação',
          pendencia: 'Aguardando embarcador selecionar transportador'
        },
        AA: {
          descricao: 'Em coleta',
          pendencia: 'Aguardando autorização para a coleta'
        },
        CO: {
          descricao: 'Em coleta',
          pendencia: 'Aguardando autorização para a coleta'
        },
        AC: {
          descricao: 'Em coleta',
          pendencia: 'Aguardando autorização para a coleta'
        },
        AE: {
          descricao: 'Em coleta',
          pendencia: 'Aguardando autorização para a coleta'
        },
        AD: {
          descricao: 'Em coleta',
          pendencia: 'Aguardando autorização para a coleta'
        },
        TR: {
          descricao: 'Em trânsito',
          pendencia: 'Aguardando entrega'
        }
      },
      options: {
        tiposVeiculo: [],
        tiposCarroceria: []
      },
      filtro: {
        embarcador: '',
        carga: '',
        motorista: '',
        status: '',
        total: 0
      },
      optionsStatus: [
        { id: 'OF', nome: 'Em oferta' },
        { id: ['NE', 'AR'], nome: 'Em negociação' },
        { id: ['AA', 'CO', 'AC', 'AE', 'AD'], nome: 'Em coleta' },
        { id: 'TR', nome: 'Em trânsito' }
      ],
      optionsEmbarcador: [],
      dialogVisible: false,
      isMobile: false
    }
  },
  computed: {
    ...mapGetters({
      getUsuario: 'getUsuario'
    }),
    oferta() {
      return this.fretesRaw.filter((frete) => frete.status === 'OF').length
    },
    negociacao() {
      return this.fretesRaw.filter((frete) => ['NE', 'AR'].includes(frete.status)).length
    },
    coleta() {
      return this.fretesRaw.filter((frete) => ['AA', 'AC', 'CO', 'AE', 'AD'].includes(frete.status)).length
    },
    transito() {
      return this.fretesRaw.filter((frete) => frete.status === 'TR').length
    },
    precoMedio() {
      if (!this.dialog.ofertasSimilares || this.dialog.ofertasSimilares.length === 0) return 0
      const total = this.dialog.ofertasSimilares
        .map((frete) => frete.valorNecociadoMotoristaSelecionado)
        .reduce((acc, total) => (acc += total), 0)
      const quantidade = this.dialog.ofertasSimilares.length
      return total / quantidade
    },
    precoMedioPorPeso() {
      if (!this.dialog.ofertasSimilares || this.dialog.ofertasSimilares.length === 0) return 0
      const total = this.dialog.ofertasSimilares
        .map((frete) => frete.valorNecociadoMotoristaSelecionado * frete.pesoNotasFiscais)
        .reduce((acc, total) => (acc += total), 0)
      const quantidade = this.dialog.ofertasSimilares
        .map((frete) => frete.pesoNotasFiscais)
        .reduce((acc, total) => (acc += total), 0)
      return (total / quantidade).toFixed(0)
    },
    precoMedioPorTipoVeiculo() {
      if (!this.dialog.ofertasSimilares || this.dialog.ofertasSimilares.length === 0) return []
      const tiposVeiculos = [...new Set(this.dialog.ofertasSimilares.map((frete) => frete.tipoVeiculo))]
      const resultado = []

      tiposVeiculos.forEach((tv) => {
        const fretesPorTipoVeiculo = this.dialog.ofertasSimilares.filter((frete) => frete.tipoVeiculo === tv)
        const total = fretesPorTipoVeiculo
          .map((frete) => frete.valorNecociadoMotoristaSelecionado)
          .reduce((acc, total) => (acc += total), 0)
        const quantidade = fretesPorTipoVeiculo.length
        const pm = (total / quantidade).toFixed(0)
        resultado.push(`${tv}: R$ ${formataMoeda(pm)}`)
      })

      return resultado
    },
    dialogNegociacoes() {
      const negociacoesAgrupadas = chain(this.dialog.data.negociacoes)
        .groupBy((negociacao) => negociacao.motorista.celular + negociacao.motorista.nome)
        .map((value, key) => ({
          motoristaCelular: value[0].motorista.celular,
          motoristaNome: value[0].motorista.nome,
          status: value[value.length - 1].status,
          negociacoes: value,
        }))
        .value()

      const nomesLiberados = this.dialog.data.negociacoes
        .filter(negociacao => negociacao.usuarioCadastroPerfil === 'P' && negociacao.usuarioCadastroNome === this.getUsuario.nome)
        .map(negociacao => negociacao.motorista.nome+negociacao.motorista.celular);

      negociacoesAgrupadas.forEach((negociacaoAgrupada) => {
        negociacaoAgrupada.negociacoes.map(negociacao => {
          if (nomesLiberados.includes(negociacao.motorista.nome+negociacao.motorista.celular)) {
            negociacao.bloqueada = false
          } else {
            negociacao.motorista.nome = '******* ** *******'
            negociacao.motorista.celular = '00000000000'
            negociacao.statusDescricao = 'Indisponível'
            negociacao.contraOferta = 0
            negociacao.data = 0
            negociacao.bloqueada = true
          }
          return negociacao
        })
      })

      return negociacoesAgrupadas
    },
    usuarioLogadoNome() {
      return this.getUsuario.nome
    },
    dialogAdicaoNegociacaoRules() {
      const rules = {
        celular: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { validator: validateCelular, message: 'Valor inválido', trigger: 'blur' }
        ],
        nome: [{ required: true, message: 'Campo obrigatório', trigger: 'blur' }],
        valor: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { validator: validateValorMinimo120, message: 'Valor mínimo igual a R$ 120,00', trigger: 'blur' }
        ],
        veiculoTipo: [{ required: true, message: 'Campo obrigatório', trigger: 'blur' }],
        carroceriaTipo: [{ required: true, message: 'Campo obrigatório', trigger: 'blur' }],
        veiculoPlaca: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { validator: validatePlaca, message: 'Valor inválido' }
        ]
      }

      if (
        this.dialogAdicaoNegociacao.form.carretaPlaca !== null &&
        this.dialogAdicaoNegociacao.form.carretaPlaca !== ''
      ) {
        rules['carretaPlaca'] = [{ validator: validatePlaca, message: 'Valor inválido' }]
      }

      if (
        this.dialogAdicaoNegociacao.form.carretaAdicionalPlaca !== null &&
        this.dialogAdicaoNegociacao.form.carretaAdicionalPlaca !== ''
      ) {
        rules['carretaAdicionalPlaca'] = [{ validator: validatePlaca, message: 'Valor inválido' }]
      }

      return rules
    },
    dialogBuscandoMotorista() {
      return this.dialogAdicaoNegociacao.buscando
    },
    dialogNegociacaoSelecionada() {
      return (
        this.dialogNegociacoes &&
        this.dialogNegociacoes.find((negociacao) => negociacao.status === 'TRANSPORTADOR_SELECIONADO_AVALIACAO_RISCO')
      )
    },
    dialogPodeAdicionarNegociacao() {
      return this.dialogNegociacaoSelecionada ? false : true
    },
    negociacaoPorUsuario() {
      return this.dialog.data.negociacoes.filter((negociacao) => negociacao.usuarioCadastroNome)
    },
  },
  watch: {
    '$route.params': function({ id }) {
      if (this.fretesRaw && this.fretesRaw.length > 0 && id) {
        const frete = this.fretesRaw.find((f) => f.id === Number(id))
        this.Abrir(frete)
      } else {
        // TODO: REMOVIDO PARA EVITAR REQUISIÇÃO REDUNDANTE
        // this.Fechar()
      }
    },
    filtro: {
      handler: function({ carga, embarcador, motorista, status }) {
        if (!this.fretesRaw) return

        const fretes = chain(this.fretesRaw)
          .filter((frete) => {
            const comCarga = carga ? String(frete.id).includes(carga) : true
            const comStatus = status ? this.comparaStatus(frete.status, status) : true
            const comEmbarcador = embarcador
              ? frete.embarcador.nome.toLowerCase().includes(embarcador.toLowerCase())
              : true
            const comMotorista = motorista
              ? frete.negociacoes.filter((negociacao) => {
                  const comNome = negociacao.motorista.nome.toLowerCase().includes(motorista.toLowerCase())
                  return comNome
                }).length
              : true
            return comCarga && comEmbarcador && comMotorista && comStatus
          })
          .groupBy((frete) => frete.embarcador.id)
          .map((value, key) => ({ embarcadorId: key, embarcadorNome: value[0].embarcador.nome, fretes: value }))
          .value()

        this.filtro.total = fretes.reduce((acc, frete) => frete.fretes.length + acc, 0)
        this.fretes = fretes
      },
      deep: true
    }
  },
  methods: {
    async CarregarLista(freteId = null) {
      if (freteId === Number(this.$route.params.id)) return

      const response = await services.listar()
      this.fretesRaw = response.data
      const fretes = chain(this.fretesRaw)
        .groupBy((frete) => frete.embarcador.id)
        .map((value, key) => ({ embarcadorId: key, embarcadorNome: value[0].embarcador.nome, fretes: value }))
        .value()
      this.fretes = fretes
      this.filtro.total = this.fretesRaw.length
      this.optionsEmbarcador = fretes
        .map((frete) => {
          return { id: frete.embarcadorNome, nome: frete.embarcadorNome }
        })
        .sort((a, b) => a.id > b.id)

      if (this.$route.params && this.$route.params.id) {
        const frete = this.fretesRaw.find((frete) => frete.id === Number(this.$route.params.id))
        this.Abrir(frete)
      }
    },
    async CarregarOptions() {
      const [responseTiposVeiculo, responseTiposCarroceria] = await Promise.all([
        services.listarTiposVeiculo(),
        services.listarTiposCarroceria()
      ])
      this.options.tiposVeiculo = chain(responseTiposVeiculo.data)
        .groupBy((item) => item.tipo)
        .map((value, key) => ({ label: key, options: orderBy(value, ['descricao'], ['asc']) }))
        .value()
      this.options.tiposCarroceria = chain(responseTiposCarroceria.data)
        .groupBy((item) => item.tipo)
        .map((value, key) => ({ label: key, options: orderBy(value, ['descricao'], ['asc']) }))
        .value()
    },

    async CarregarMotoristaSelecionado() {
      const frete = this.dialog.data

      if (frete && frete.direcionamentoMotoristaSelecionado != null) {
        try {
          // this.dialog.precoMedioCarregando = true
          const response = await services.buscarMotoristaSelecionado(frete.direcionamentoMotoristaSelecionado)
          this.dialog.motoristaSelecionado = response.data
        } catch (error) {
          this.$notify.error({
            title: 'Atenção!',
            title: 'Não foi possível carregar motorista selecionado',
            message: error.response.data.message,
            offset: 0
          })
        } finally {
          // this.dialog.precoMedioCarregando = false
        }
      } else {
        this.dialog.motoristaSelecionado = null
      }
    },
    Abrir(frete) {
      this.dialog.visible = true
      this.dialog.data = frete

      if (this.$route.path !== '/parceiro/contratacao/' + frete.id) {
        this.$router.push({ path: '/parceiro/contratacao/' + frete.id })
      }
    },
    Fechar() {
      this.CarregarLista()
      this.dialog.visible = false
      this.dialog.consultaAprovada = false
      this.$router.push({ path: '/parceiro/contratacao' })
    },
    AbrirNegociacao(negociacao) {
      this.dialogNegociacao.visible = true
      this.dialogNegociacao.data = negociacao
    },
    FecharNegociacao() {
      this.dialogNegociacao.visible = false
      this.dialogNegociacao.data = null
    },
    AbrirAdicaoNegociacao() {
      this.CarregarOptions()
      this.dialogAdicaoNegociacao.visible = true
      this.dialogAdicaoNegociacao.form.freteId = this.dialog.data.id
    },
    FecharAdicaoNegociacao() {
      this.dialogAdicaoNegociacao.visible = false
      this.$refs.formDialogAdicaoNegociacao.clearValidate()
      this.LimparDadosMotoristaVeiculo()
      this.dialogAdicaoNegociacao.form.celular = null
    },
    AbrirUltimasOfertas() {
      this.dialogUltimasOfertas.visible = true
    },
    FecharUltimasOfertas() {
      this.dialogUltimasOfertas.visible = false
    },
    AbrirMotoristasPorPerfil() {
      this.dialogMotoristasPorPerfil.visible = true
    },
    FecharMotoristasPorPerfil() {
      this.dialogMotoristasPorPerfil.visible = false
    },
    ExtrairNegociacaoPorId(negociacaoId) {
      for (let index = 0; index < this.fretesRaw.length; index++) {
        const frete = this.fretesRaw[index]
        const negociacoes = frete.negociacoes

        for (let i = 0; i < negociacoes.length; i++) {
          const negociacao = negociacoes[i]

          if (negociacao.id === negociacaoId) {
            return negociacao
          }
        }
      }
    },
    async EstornarDesistencia(negociacaoId) {
      if (this.dialog.estornando !== null) return

      const negociacao = this.ExtrairNegociacaoPorId(negociacaoId)

      const vm = this
      confirmar(
        'Atenção!',
        `Deseja realmente estornar a desistência do motorista ${negociacao.motorista.nome}?`,
        async function() {
          try {
            vm.dialog.estornando = negociacaoId
            const freteId = vm.dialog.data.id
            const response = await services.estornarDestistencia(negociacaoId)

            if (response) {
              await vm.CarregarLista()
              const frete = vm.fretesRaw.find((frete) => frete.id === freteId)
              vm.Abrir(frete)

              if (vm.dialogNegociacao.data) {
                const { motoristaNome, motoristaCelular } = vm.dialogNegociacao.data
                const negociacoes = vm.dialogNegociacoes.filter(
                  (negociacao) =>
                    negociacao.motoristaNome === motoristaNome && negociacao.motoristaCelular === motoristaCelular
                )
                vm.AbrirNegociacao(negociacoes[0])
              }

              vm.$notify.success({
                title: 'Parabêns',
                message: 'Estorno de desistência realiazado com sucesso',
                offset: 0
              })
            }
          } catch (error) {
            vm.$notify.error({
              title: 'Atenção!',
              message: 'Não foi possível estornar desistência',
              offset: 0
            })
          } finally {
            vm.dialog.estornando = null
          }
        },
        function() {}
      )
    },
    async DesitirFrete(negociacaoId) {
      if (this.dialog.desistindo !== null) return

      const negociacao = this.ExtrairNegociacaoPorId(negociacaoId)

      const vm = this
      confirmar(
        'Atenção!',
        `Deseja realmente reportar desistência da oferta pelo motorista ${negociacao.motorista.nome}?`,
        async function() {
          try {
            vm.dialog.desistindo = negociacaoId
            const freteId = vm.dialog.data.id
            const response = await services.desistirFrete(negociacaoId)

            if (response) {
              await vm.CarregarLista()
              const frete = vm.fretesRaw.find((frete) => frete.id === freteId)
              vm.Abrir(frete)

              if (vm.dialogNegociacao.data) {
                const { motoristaNome, motoristaCelular } = vm.dialogNegociacao.data
                const negociacoes = vm.dialogNegociacoes.filter(
                  (negociacao) =>
                    negociacao.motoristaNome === motoristaNome && negociacao.motoristaCelular === motoristaCelular
                )
                vm.AbrirNegociacao(negociacoes[0])
              }

              vm.$notify.success({
                title: 'Parabêns',
                message: 'Desistência realiazada com sucesso',
                offset: 0
              })
            }
          } catch (error) {
            vm.$notify.error({
              title: 'Atenção!',
              message: 'Não foi possível desistir do frete',
              offset: 0
            })
          } finally {
            vm.dialog.desistindo = null
          }
        },
        function() {}
      )
    },
    async AceitarContraofertaFrete(negociacaoId) {
      if (this.dialog.aceitando !== null) return

      const negociacao = this.ExtrairNegociacaoPorId(negociacaoId)

      const vm = this
      confirmar(
        'Atenção!',
        `Deseja realmente aceitar contraoferta do embarcador pelo motorista ${negociacao.motorista.nome}?`,
        async function() {
          try {
            vm.dialog.aceitando = negociacaoId
            const freteId = vm.dialog.data.id
            const response = await services.aceitarContraofertaFrete(negociacaoId)

            if (response) {
              await vm.CarregarLista()
              const frete = vm.fretesRaw.find((frete) => frete.id === freteId)
              vm.Abrir(frete)

              vm.$notify.success({
                title: 'Parabêns',
                message: 'Aceite de contraoferta realiazada com sucesso',
                offset: 0
              })
            }
          } catch (error) {
            vm.$notify.error({
              title: 'Atenção!',
              message: 'Não foi possível aceitar a contraoferta do embarcador',
              offset: 0
            })
          } finally {
            vm.dialog.aceitando = null
          }
        },
        function() {}
      )
    },
    async AdicionarNegociacao() {
      try {
        this.dialogAdicaoNegociacao.adicionando = true

        this.$refs.formDialogAdicaoNegociacao.clearValidate()
        this.$refs.formDialogAdicaoNegociacao.validate((valid) => {
          if (!valid) throw new Error('Existem erros no formulário, corríja-os antes de prosseguir.')
        })

        const form = JSON.parse(JSON.stringify(this.dialogAdicaoNegociacao.form))
        form.celular = form.celular.replace(/[^0-9]/g, '')
        form.valor = converteMoeda(form.valor)
        const response = await services.adicionarNegociacao(form)

        if (response) {
          this.$notify.success({
            title: 'Parabéns',
            message: 'Negociação adicionada com sucesso',
            offset: 100,
            duration: 0
          })
          await this.CarregarLista()
          this.FecharAdicaoNegociacao()
          const frete = this.fretesRaw.find((f) => f.id === form.freteId)
          this.Abrir(frete)
        }
      } catch (error) {
        this.$notify.error({
          title: 'Atenção!',
          message: error.message,
          offset: 100,
          duration: 0
        })
      } finally {
        this.dialogAdicaoNegociacao.adicionando = false
      }
    },
    async BuscarMototoristaPorCelular() {
      try {
        this.dialogAdicaoNegociacao.motoristaBuscadoJaCadastrado = false
        if (this.dialogAdicaoNegociacao.form.celular === null) return
        this.dialogAdicaoNegociacao.buscando = true
        const celular = JSON.parse(JSON.stringify(this.dialogAdicaoNegociacao.form.celular)).replace(/[^0-9]/g, '')
        if (celular.length !== 11) return

        const response = await services.listarMototoristaPorCelular(celular)

        if (response) {
          const transportadores = response.data

          if (transportadores.length) {
            this.dialogAdicaoNegociacao.motoristaBuscadoJaCadastrado = true

            this.$notify.warning({
              title: 'Aviso!',
              message: `Atenção! O motorista do celular ${celular} já está cadastrado em nossa base e foi notificado sobre a carga. Por isso, é importante destacar que existe o risco de ele fazer negociações diretas com o embarcador.`,
              offset: 100,
              duration: 0,
            })
          }
        }
      } catch (error) {
        this.$notify.error({
          title: 'Atenção!',
          message: error.message,
          offset: 100,
          duration: 0
        })
      } finally {
        this.dialogAdicaoNegociacao.buscando = false
      }
    },
    async BuscarMototoristaPorCpf() {
      try {
        if (this.dialogAdicaoNegociacao.form.cpf === null) return
        this.dialogAdicaoNegociacao.buscando = true
        const cpf = JSON.parse(JSON.stringify(this.dialogAdicaoNegociacao.form.cpf)).replace(/[^0-9]/g, '')
        if (cpf.length !== 11) return

        const response = await services.buscarMototoristaPorCpf(cpf)

        if (response) {
          const transportador = response.data
          this.LimparDadosMotoristaVeiculo()
          this.AtualizarDadosMotoristaVeiculo(transportador)
        }
      } catch (error) {
        this.$notify.error({
          title: 'Atenção!',
          message: error.message,
          offset: 100,
          duration: 0,
        })
      } finally {
        this.dialogAdicaoNegociacao.buscando = false
      }
    },
    AtualizarDadosMotoristaVeiculo(transportador) {
      this.dialogAdicaoNegociacao.form.nome = transportador.usuarioNome
      this.dialogAdicaoNegociacao.form.celular = transportador.usuarioCelular
      this.dialogAdicaoNegociacao.form.usuarioId = transportador.usuarioId
      this.dialogAdicaoNegociacao.form.veiculoTipo = transportador.veiculoTipo
      this.dialogAdicaoNegociacao.form.carroceriaTipo = transportador.carroceriaTipo
      this.dialogAdicaoNegociacao.form.veiculoPlaca = transportador.veiculoPlaca
      this.dialogAdicaoNegociacao.form.carretaPlaca = transportador.carretaPlaca
      this.dialogAdicaoNegociacao.form.carretaAdicionalPlaca = transportador.carretaAdicionalPlaca
    },
    LimparDadosMotoristaVeiculo() {
      this.dialogAdicaoNegociacao.form.nome = null
      this.dialogAdicaoNegociacao.form.usuarioId = null
      this.dialogAdicaoNegociacao.form.veiculoTipo = null
      this.dialogAdicaoNegociacao.form.carroceriaTipo = null
      this.dialogAdicaoNegociacao.form.veiculoPlaca = null
      this.dialogAdicaoNegociacao.form.carretaPlaca = null
      this.dialogAdicaoNegociacao.form.carretaAdicionalPlaca = null
      this.dialogAdicaoNegociacao.form.valor = 0
    },
    async ReprovarMotorista() {
      const negociacao = this.dialogNegociacaoSelecionada
      const vm = this
      confirmar(
        'Atenção!',
        `Deseja realmente reprovar o motorista ${negociacao.motoristaNome}? A carga retornará para Em Negociação e o Embarcador precisará selecionar um motorista novamente.`,
        async function() {
          try {
            const response = await services.reprovarMotorista(
              negociacao.negociacoes[negociacao.negociacoes.length - 1].id
            )

            if (response) {
              await vm.CarregarLista()

              vm.$notify.success({
                title: 'Parabêns',
                message: 'Motorista reprovado com sucesso.',
                offset: 100
              })

              vm.$notify.warning({
                title: 'Atenção!',
                message:
                  'Informe ao Embarcador que o motorista foi reprovado na avaliação de risco e será necessário selecionar outro motorista para a carga.',
                offset: 197,
                duration: 0
              })
            }
          } catch (error) {
            const motivo = error.message
              ? error.message
              : error.data.message
              ? error.data.message
              : 'Motivo não identificado'
            const mensagem = 'Não foi possível reprovar o motorista. Motivo: ' + motivo
            vm.$notify.error({
              title: 'Atenção!',
              message: mensagem,
              offset: 0
            })
          } finally {
            vm.dialog.estornando = null
          }
        },
        function() {}
      )
    },
    LigarEventos() {
      const vm = this

      this.$bus.$on('transportador-aprovado', (freteId) => {
        vm.CarregarLista(freteId)
        vm.$notify.success({
          title: 'Parabêns!',
          message: `Carga ${freteId} - Motorista aprovado. A carga foi movida para autorização de coleta.`,
          offset: 100,
          duration: 0
        })
        vm.dialog.data.pendencia.mensagens.pop()
        vm.dialog.data.pendencia.mensagens.push('Consulta de risco aprovada')
        vm.dialog.consultaAprovada = true
      })

      this.$bus.$on('administrador-frete-atualizado', () => vm.CarregarLista())

      this.$bus.$on('embarcador-contraofertou', () => vm.CarregarLista())

      this.$bus.$on('embarcador-selecionou', () => vm.CarregarLista())

      this.$bus.$on('transportador-reprovado', (freteId) => {
        vm.CarregarLista()
        vm.$notify.warning({
          title: 'Atenção!',
          message: `Carga ${freteId} - Motorista reprovado na consulta de risco.`,
          offset: 100,
          duration: 0
        })
      })

      this.$bus.$on('transportador-analise', () => vm.CarregarLista())
    },
    MutarEventos() {
      this.$bus.$off('transportador-aprovado')
      this.$bus.$off('administrador-frete-atualizado')
      this.$bus.$off('embarcador-contraofertou')
      this.$bus.$off('embarcador-selecionou')
      this.$bus.$off('transportador-reprovado')
      this.$bus.$off('transportador-analise')
    },
    atualizarIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    comparaStatus(freteStatus, filtroStatus) {
      if (Array.isArray(filtroStatus)) {
        return filtroStatus.some((status) => freteStatus.includes(status))
      } else {
        return freteStatus.includes(filtroStatus)
      }
    },
    converterDataParaSerialParaData(dataString) {
      const dataObj = new Date(dataString);
      dataObj.setHours(dataObj.getHours() + 3);

      const dataReferencia = new Date("1899-12-30");
      const diferencaEmMilissegundos = dataObj - dataReferencia;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);
      const dataSerial = Math.floor(diferencaEmDias);

      const dataEmMilissegundos = dataReferencia.getTime() + dataSerial * (1000 * 60 * 60 * 24);
      const dataFormatada = new Date(dataEmMilissegundos);
      const dia = String(dataFormatada.getDate()).padStart(2, "0");
      const mes = String(dataFormatada.getMonth() + 1).padStart(2, "0");
      const ano = dataFormatada.getFullYear();

      return `${dia}/${mes}/${ano}`;
    },
    formatarMoeda(valor) {
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    extrairDados(fretes) {
      const dadosExtraidos = {};

      fretes.map((info) => {
        info.fretes.map((frete) => {
          if (['OF', 'NE', 'AR'].includes(frete.status)) {
            if (!dadosExtraidos[frete.id]) {
              // Verifica se há mais de uma entrega para o frete, senão usa o array com a única entrega
              const entregas = frete.entregas.length > 0 ? frete.entregas : [frete.entrega];
              let valorTotalNF = 0;

              entregas.map((entrega) => {
                valorTotalNF += entrega.valorNotaFiscal;

                dadosExtraidos[frete.id] = {
                  "Nº Carga": frete.id,
                  "Empresa": info.embarcadorNome,
                  "Origem": frete.coleta.cidade.nome,
                  "Destino": entrega.cidade.nome,
                  "Data da Coleta": this.converterDataParaSerialParaData(frete.coleta.data),
                  "Valor do Frete": this.formatarMoeda(frete.valorOfertadoEmbarcador),
                  "Valor Estimado NF": this.formatarMoeda(valorTotalNF),
                  "Perfil do Veículo": frete.tiposVeiculo.join("; "),
                  "Perfil da Carroceria": frete.tiposCarroceria.join("; "),
                  "Observação": frete.coleta.observacao,
                };
              });
            }
          }
        });
      });
      return Object.values(dadosExtraidos);
    },

    criarPlanilhaExcel(dados) {
      const nomeColunas = [
        "Nº Carga",
        "Empresa",
        "Origem",
        "Destino",
        "Data da Coleta",
        "Valor do Frete",
        "Valor Estimado NF",
        "Perfil do Veículo",
        "Perfil da Carroceria",
        "Observação"
      ];

      const conteudoPlanilha = [nomeColunas, ...dados.map(Object.values)];

      // Aplicando o estilo de cabeçalho para a primeira linha (índice 0)
      conteudoPlanilha[0] = conteudoPlanilha[0].map((cellValue, index) => {
        const alinhamento = [4].includes(index) ? 'right' : 'left'
        return { v: cellValue, ...{ t: 's', s: { alignment: { horizontal: alinhamento } } } }
      });

      // Aplicando o estilo de conteúdo para as linhas restantes (índices 1 em diante)
      for (let i = 1; i < conteudoPlanilha.length; i++) {
        conteudoPlanilha[i] = conteudoPlanilha[i].map((cellValue, index) => {
          const alinhamento = [4, 5, 6].includes(index) ? 'right' : 'left'
          return { v: cellValue, ...{ t: 's', s: { alignment: { horizontal: alinhamento } } } }
        });
      }

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(conteudoPlanilha);

      const colWidths = nomeColunas.map((col) => ({ wch: col.length + 2 }));
      worksheet["!cols"] = colWidths;

      XLSX.utils.book_append_sheet(workbook, worksheet, "Cargas");

      const nomeArquivo = "cargas.xlsx";
      XLSX.writeFile(workbook, nomeArquivo);
    },
    gerarPlanilha() {
      const dadosExtraidos = this.extrairDados(this.fretes);
      if (dadosExtraidos.length === 0) {
        this.$notify.warning({
          title: 'Aviso!',
          message: `Atenção! Não existem cargas para exportar. Verifique os filtros aplicados.`,
          offset: 100,
          duration: 0,
        });
        return;
      }
      this.criarPlanilhaExcel(dadosExtraidos);
    },
  },
  mounted() {
    this.CarregarLista()
    this.MutarEventos()
    this.LigarEventos()
    window.addEventListener('resize', this.atualizarIsMobile)
    this.atualizarIsMobile()
  },
  destroyed() {
    this.MutarEventos()
    window.removeEventListener('resize', this.atualizarIsMobile)
  }
}
</script>

<style>
#Contratacao .el-dialog__header {
  background-color: #dc2626;
  color: white !important;
  font-weight: 600;
}

#Contratacao .el-dialog__title {
  color: white !important;
}

#Contratacao .el-dialog__close {
  color: white !important;
  background-color: #ffffff20;
  padding: 5px;
  border-radius: 25px;
  margin-top: -5px;
  margin-right: -5px;
}

#Contratacao .cards {
  display: flex;
}

#Contratacao .cards .el-col {
  width: 25%;
  padding: 10px;
}

#Contratacao .status {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  padding-top: 8px;
  padding-bottom: 5px;
}

#Contratacao .status .total {
  margin-top: 15px;
  font-size: 45px;
  font-weight: bold;
}

#Contratacao .filtros {
  margin-bottom: 15px;
}

#Contratacao .filtros .el-col {
  width: 25%;
  padding: 10px;
}

#Contratacao .label-center {
  text-align: center;
}

#Contratacao .el-dialog__body {
  word-break: normal;
}

#Contratacao .no-hover tbody tr:hover,
#Contratacao .no-hover tr:hover > td.el-table__cell {
  background-color: white !important;
}

#Contratacao .el-timeline-item:last-child {
  padding-bottom: 0;
}

#Contratacao .el-timeline-item:last-child {
  padding-bottom: 0;
}

#Contratacao .el-timeline-item__node--normal,
#Contratacao .el-timeline-item__tail {
  margin-top: 3px;
}

#Contratacao .btn.vermelho:hover {
  color: #dc2626;
}

.selecao-motorista {
  cursor: pointer;
}

.selecao-motorista tr td:hover {
  background-color: #ef66383d;
}

.selecao-motorista .selecionado {
  background-color: #ef66383d;
}

#Contratacao .cardContratacao {
  margin: 10px;
}

#Contratacao .cardContratacao .conteudo {
  margin: 10px;
}

#Contratacao .cardCabecalho {
  background-color: #dc2626;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#Contratacao .desktop-component {
  display: block;
}

#Contratacao .mobile-component {
  display: none;
}

@media screen and (max-width: 768px) {
  #Contratacao .cards {
    flex-wrap: wrap;
  }

  #Contratacao .cards .el-col {
    min-width: 50%;
  }

  #Contratacao .status {
    font-size: 15px;
  }

  #Contratacao .filtros .el-col {
    width: 100%;
  }

  #Contratacao .desktop-component {
    display: none !important;
  }

  #Contratacao .mobile-component {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/Parceiro/Contratacao/components/Main.vue